import { createSelector } from 'reselect'
import { isLoyaltyTransferItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'

/**
 * Retrieves all loyalty airport transfer items in the checkout
 */
const getLoyaltyTransferItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items) => {
    return items.filter(isLoyaltyTransferItem)
  },
  reselectShallowEqual,
)

export default getLoyaltyTransferItems
